export const es = {
    'words': 'LEMA',
    'seat':'SEDE',
    'region':'REGION',
    'allegiances':'ALIANZAS',
    'religion':'RELIGIONES',
    'fundation':'FUNDACION',
    'siblings': 'DESCENDIENTES',
    'titles': 'TÍTULOS',
    'appearances': 'APARICIONES',
    'father': 'PADRE',
    'house': 'CASA',
    'characters':'PERSONAJES',
    'chronology':'CRONOLOGIA',
    'houses': 'CASAS',
    'game': 'JUEGO',
    'of': 'DE',
    'thrones': 'TRONOS',

}
